import { ExternalEvent } from "@/TS/Interfaces/global_interfaces";

/**
 * Sorts external events by start date in ascending order (earliest first)
 * @param events - Array of external events to sort
 * @returns Sorted array with earliest events first
 */
export const sortEventsByStartDate = (
  events: ExternalEvent[],
): ExternalEvent[] => {
  return events.sort((a, b) => {
    return new Date(a.startDate).getTime() - new Date(b.startDate).getTime();
  });
};
